import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { format } from '@shared/utilities/formatEmail';

const baseUrl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class WalletService {
  constructor(private _http: HttpClient) {}

  getTransactions(
    username,
    transactionStatusId,
    pageSize = 8,
    pageNumber = 1
  ): Observable<any> {
    return this._http.get(
      `${baseUrl}/users/${format(
        username
      )}/transactions/${transactionStatusId}?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  }

  getUserWalletBalance(username): Observable<any> {
    return this._http.get(
      `${baseUrl}/users/${format(username)}/digital-wallet`
    );
  }
}
